import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

const STORAGE_KEY = "gs_cookie_consent_v1";

export default function CookieConsent() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) {
        const t = setTimeout(() => setOpen(true), 800);
        return () => clearTimeout(t);
      }
    } catch (e) {
      setOpen(true);
    }
  }, []);

  const setChoice = (choice) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, at: new Date().toISOString() })
      );
    } catch (e) {
      // ignore
    }
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-6 lg:left-auto lg:right-6 lg:max-w-[520px] z-[60] bg-[#111111] text-white border border-[#D4AF37]/40 shadow-[0_30px_60px_-20px_rgba(0,0,0,0.8)] p-5 sm:p-7"
          data-testid="cookie-consent"
          role="dialog"
          aria-live="polite"
        >
          <div className="text-[10px] tracking-[0.32em] uppercase text-[#D4AF37] mb-3">
            Cookies
          </div>
          <h3
            className="font-serif text-xl sm:text-2xl leading-tight text-white mb-3 font-light"
            style={{ fontFamily: "Fraunces, serif" }}
          >
            Vi bruger cookies
          </h3>
          <p className="text-white/70 text-sm font-light leading-relaxed mb-5">
            Vi bruger nødvendige cookies for at siden fungerer, og statistik-cookies
            til at forstå hvordan siden bruges. Du kan læse mere i vores{" "}
            <Link
              to="/cookies"
              className="text-[#D4AF37] underline hover:text-white transition-colors"
            >
              cookiepolitik
            </Link>
            {" "}og{" "}
            <Link
              to="/privatlivspolitik"
              className="text-[#D4AF37] underline hover:text-white transition-colors"
            >
              privatlivspolitik
            </Link>
            .
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              type="button"
              onClick={() => setChoice("accepted")}
              data-testid="cookie-accept-btn"
              className="flex-1 bg-[#D4AF37] text-[#111111] px-5 py-3 text-[11px] uppercase tracking-[0.15em] font-medium hover:bg-white transition-colors"
            >
              Accepter alle
            </button>
            <button
              type="button"
              onClick={() => setChoice("necessary")}
              data-testid="cookie-necessary-btn"
              className="flex-1 border border-white/25 text-white/85 px-5 py-3 text-[11px] uppercase tracking-[0.15em] font-medium hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
            >
              Kun nødvendige
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
